var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex align-center host-roles-component"},_vm._l((_vm.hostRoles),function(it,i){return _c('div',{key:i},[_c('v-chip',{staticClass:"host-role-chip ml-2 pa-1",class:_vm.getChipColor(it),attrs:{"label":""}},[_vm._v(_vm._s(it.text))])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }